import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
import "moment/locale/vi";
import moment from "moment";
import LoadingIcons from "react-loading-icons";
import { ToastContainer, toast } from "react-toastify";
import {
    getInvoiceLinkAPI,
    getCompanyFound,
    getDataExpense,
    getFile,
} from "../services/UserService";
import iconImage from "../assets/images/iconImage.svg";
import {
    Button,
    DatePicker,
    Input,
    Modal,
    Popover,
    Select,
} from "antd";
import { getImageSize } from "react-image-size";
import * as FileSaver from "file-saver";
import { TfiReload } from "react-icons/tfi";
import Header from "./Header";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { MapContainer, TileLayer } from "react-leaflet";
import RoutineMachine from "./RoutineMachine";

import { FormControl, Grid } from "@mui/material";
import { CustomTextFieldStyle } from "../styles/home/CustomStyle";
import Pagination from "@mui/material/Pagination";
import "../../src/assets/scss/table.data.css";
import { TbFileSearch } from "react-icons/tb";
import GalleryImages from "./GalleryImages";
import Footer from "./Footer";


const DataTable = (props) => {
    const navigate = useNavigate();
    const isLogin = localStorage.getItem("isLogin");
    const limitRow = localStorage.getItem("limitRow")
        ? localStorage.getItem("limitRow")
        : 20;
    const dateFormat = "DD/MM/YYYY";
    const [limit, setLimit] = useState(Number(limitRow));
    if (!isLogin || isLogin === false) {
        navigate("/login");
    }

    const [index, setIndex] = useState(1);
    const [, setMinIndex] = useState(1);
    const [, setMaxIndex] = useState(20);
    const [data, setData] = useState("");
    const token = localStorage.getItem("token");
    const [dataError, setDataError] = useState(
        <LoadingIcons.Puff stroke="#0059a9" />
    );
    const [pageNumbers, setPageNumber] = useState(0);
    const [forcePage, setForcePage] = useState(0);

    const [contNumber, setContNumber] = useState("");
    const [company, setCompany] = useState("");
    const [companyListFound, setCompanyListFound] = useState("");
    const [, setCompanyListLoaded] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showImages, setShowImages] = useState(false);

    const [urlImages, setUrlImages] = useState([
        {
            url: null,
            name: null,
            width: 0,
            height: 0,
        },
    ]);

    //modal

    const [openMap, setOpenMap] = useState(false);



    const [latStart, setLatStart] = useState(null);
    const [longStart, setLongStart] = useState(null);
    const [latEnd, setLatEnd] = useState(null);
    const [longEnd, setLongEnd] = useState(null);
    const [markerPopup, setMarkerPopup] = useState(null);
    const [markerPopupType] = useState(null);
    const [color, setColor] = useState("blue");
    const [currentPage, setCurrentPage] = useState(1);
    const [reset, setReset] = useState(true);

    // active img

    const [showPagination, setShowPagination] = useState(true);

    const [, setWidthXh] = useState(0);
    const refXh1 = useRef(null);
    const refXh2 = useRef(null);
    const refXh3 = useRef(null);
    const refXh4 = useRef(null);
    const refXh5 = useRef(null);
    const refXh6 = useRef(null);
    const refXh7 = useRef(null);
    const refXh8 = useRef(null);
    const refXh9 = useRef(null);
    const refXh10 = useRef(null);

    const [, setWidthXl] = useState(0);
    const refXl1 = useRef(null);
    const refXl2 = useRef(null);

    const optionsData = [];
    if (companyListFound) {
        companyListFound.split("\r").forEach((value) => {
            optionsData.push({
                value: value,
                label: value,
            });
        });
    }


    function getDataTable(inputDate, inputCompany, inputCont, limit, offset) {
        setData("");
        setDataError(<LoadingIcons.Puff stroke="#0059a9" />);
        getDataExpense(
            inputDate,
            inputCompany,
            inputCont,
            limit,
            offset,
            token
        )
            .then((res) => {
                if (res.data.messages[0].message === "OK") {
                    setData(res.data.response.data);
                    setPageNumber(res.data.response.dataInfo.foundCount);
                    if (res.data.response.dataInfo.foundCount <= limit) {
                        setShowPagination(false);
                    } else {
                        setShowPagination(true);
                    }
                } else {
                    setData("");
                    setDataError('Không có dữ liệu tương ứng!');
                }
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    navigate("/login");
                } else if (error.response.status === 500) {
                    setData("");
                    setIndex(1);
                    setPageNumber(0);
                    setDataError("Không có dữ liệu tương ứng!");
                }
            });
    }

    const handleChangePage = (event, newPage) => {
        const formatStart = startDate
            ? startDate.format("MM/DD/YYYY").toString()
            : "";
        const formatEnd = endDate ? endDate.format("MM/DD/YYYY").toString() : "";
        const inputDate = formatStart + ".." + formatEnd;
        const inputCompany = company ? company : "*";
        const inputCont = contNumber ? `*${contNumber}*` : "*";
        const offset = limitRow * (newPage - 1) + 1;
        setCurrentPage(offset);

        getDataTable(
            inputDate,
            inputCompany,
            inputCont,

            limitRow,
            offset
        );
    };


    const handleChangeLimit = (value) => {
        setLimit(value);
        const formatStart = startDate
            ? startDate.format("MM/DD/YYYY").toString()
            : "";
        const formatEnd = endDate ? endDate.format("MM/DD/YYYY").toString() : "";
        const inputDate = formatStart + ".." + formatEnd;
        const inputCompany = company ? company : "*";
        const inputCont = contNumber ? `*${contNumber}*` : "*";
        getDataTable(inputDate, inputCompany, inputCont, value, 1);
        localStorage.setItem("limitRow", value);
    };

    function getCompanyListFound() {
        // Lấy date hiện tại từ startDate và endDate
        const formatStart = startDate
            ? startDate.format("MM/DD/YYYY").toString()
            : "";
        const formatEnd = endDate ? endDate.format("MM/DD/YYYY").toString() : "";
        const inputDate = formatStart + ".." + formatEnd;

        if (!formatStart || !formatEnd) {
            return;
        }

        setCompanyListFound("");
        getCompanyFound(token, inputDate).then((res) => {
            if (res.data.messages[0].message === "OK") {
                // Lấy danh sách CONG_TY unique từ response, remove duplicate và sort
                const dataList = res.data.response.data || [];
                const uniqueCompanies = [...new Set(dataList.map(item => item.fieldData.CONG_TY).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'vi'));
                setCompanyListFound(uniqueCompanies.join("\r"));
                setCompanyListLoaded(true);
            } else {
                setCompanyListFound("");
                setCompanyListLoaded(true);
            }
        }).catch(() => {
            setCompanyListFound("");
            setCompanyListLoaded(true);
        });
    }

    // Handler khi mở dropdown Select công ty
    const handleCompanyDropdownVisibleChange = (open) => {
        if (open) {
            // Luôn reload để lấy danh sách công ty mới theo date range hiện tại
            setCompanyListLoaded(false);
            getCompanyListFound();
        }
    };

    function getWidthVehicle() {
        setWidthXh(0);
        setWidthXh(
            refXh1.current.offsetWidth +
            refXh2.current.offsetWidth +
            refXh3.current.offsetWidth +
            refXh4.current.offsetWidth +
            refXh5.current.offsetWidth +
            refXh6.current.offsetWidth +
            refXh7.current.offsetWidth +
            refXh8.current.offsetWidth +
            refXh9.current.offsetWidth +
            refXh10.current.offsetWidth
            // refXh11.current.offsetWidth +
            // refXh12.current.offsetWidth
        );
        setWidthXl(0);
        setWidthXl(refXl1?.current.offsetWidth + refXl2?.current.offsetWidth);
    }

    const isInitializedRef = useRef(false);


    const handleSubmit = async () => {
        const elements = document.getElementsByClassName("hide-element");
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.setProperty("display", "block", "important");
        }
        setForcePage(0);
        if (startDate && endDate) {
            const diffDays = endDate.diff(startDate, "days");
            if (diffDays > 60) {
                toast.error("Khoảng thời gian không được quá 60 ngày");
                return;
            }
        } else {
            toast.error("Vui lòng nhập đầy đủ ngày bắt đầu và ngày kết thúc.");
            return;
        }

        const formatStart = startDate
            ? startDate.format("MM/DD/YYYY").toString()
            : "";
        const formatEnd = endDate ? endDate.format("MM/DD/YYYY").toString() : "";

        const inputDate = formatStart + ".." + formatEnd;
        const inputCompany = company ? company : "*";
        const inputCont = contNumber ? `*${contNumber}*` : "*";
        if (formatStart && formatEnd) {
            setData("");
            setIndex(1);
            setMinIndex(1);
            setMaxIndex(20);
            setPageNumber(1);
            getDataTable(
                inputDate,
                inputCompany,
                inputCont,

                limitRow,
                1
            );
            setCompanyListLoaded(false);
        } else if ((startDate && !endDate) || (!startDate && endDate)) {
            toast.error("Vui lòng nhập đầy đủ ngày bắt đầu và ngày kết thúc.");
            setData("");
            setIndex(1);
            setPageNumber(1);
            setMinIndex(1);
            setMaxIndex(20);
            getDataTable(
                inputDate,
                inputCompany,
                inputCont,

                limitRow,
                1
            );
            setCompanyListLoaded(false);
        }
    };

    const handleSubmitWithAction = async (action) => {
        setForcePage(0);
        setData("");
        setIndex(1);
        setMinIndex(1);
        setMaxIndex(20);
        setPageNumber(1);
        const elements = document.getElementsByClassName("hide-element");
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.setProperty("display", "block", "important");
        }
        let formatStart;
        let formatEnd;

        let today = moment();
        let thisMonth = moment([moment().year(), moment().month()]);

        switch (action) {
            case "yesterday":
                formatStart = moment(today).add(-1, "days");
                formatEnd = moment(today).add(-1, "days");
                break;
            case "today":
                formatStart = today;
                formatEnd = today;
                break;
            case "tomorrow":
                formatStart = moment(today).add(1, "days");
                formatEnd = moment(today).add(1, "days");
                break;
            case "thismonth":
                formatStart = moment([moment().year(), moment().month()]);
                formatEnd = moment(formatStart).endOf("month");
                break;
            case "lastmonth":
                formatStart = moment(thisMonth).add(-1, "months");
                formatEnd = moment(formatStart).endOf("month");
                break;
            default:
                formatStart = today;
                formatEnd = today;
                break;
        }

        let start = dayjs(
            moment(formatStart, "YYYY-MM-DD")
                .format()
                .toString(),
            "YYYY-MM-DD"
        );
        let end = dayjs(
            moment(formatEnd, "YYYY-MM-DD")
                .format()
                .toString(),
            "YYYY-MM-DD"
        );

        formatStart = moment(formatStart, "YYYY-MM-DD")
            .format("MM/DD/YYYY")
            .toString();
        formatEnd = moment(formatEnd, "YYYY-MM-DD")
            .format("MM/DD/YYYY")
            .toString();

        setStartDate(start);
        setEndDate(end);

        let stringDate = "*";
        if (formatStart && formatEnd) {
            stringDate = formatStart + ".." + formatEnd;
        }
        const inputDate = stringDate;
        const inputCompany = company ? company : "*";
        const inputCont = contNumber ? `*${contNumber}*` : "*";
        getDataTable(inputDate, inputCompany, inputCont, limitRow, 1);
        setCompanyListLoaded(false);
    };

    function hideElementOnSelect() {
        const elements = document.getElementsByClassName("hide-element");
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.setProperty("display", "none", "important");
        }
    }

    function onSelectStartDate(date, dateString) {
        setStartDate(date);
        setData("");
        setDataError("");
        hideElementOnSelect();
    }

    function onSelectEndDate(date, dateString) {
        setEndDate(date);
        setData("");
        setDataError("");
        hideElementOnSelect();
    }

    const onContNumber = (value) => {
        setData("");
        setDataError("");
        hideElementOnSelect();
        const newContNumber = value ? value : "*";
        setContNumber(newContNumber);

        // Gọi API với giá trị mới
        if (startDate && endDate) {
            const formatStart = startDate.format("MM/DD/YYYY").toString();
            const formatEnd = endDate.format("MM/DD/YYYY").toString();
            const inputDate = formatStart + ".." + formatEnd;
            const inputCompany = company ? company : "*";
            const inputCont = value ? `*${value}*` : "*";
            getDataTable(inputDate, inputCompany, inputCont, limitRow, 1);
        }
    };

    const onChangeCompany = (value) => {
        setData("");
        setDataError("");
        hideElementOnSelect();
        const newCompany = value ? value : "*";
        setCompany(newCompany);

        // Gọi API với giá trị mới
        if (startDate && endDate) {
            const formatStart = startDate.format("MM/DD/YYYY").toString();
            const formatEnd = endDate.format("MM/DD/YYYY").toString();
            const inputDate = formatStart + ".." + formatEnd;
            const inputCompany = value ? value : "*";
            const inputCont = contNumber ? `*${contNumber}*` : "*";
            getDataTable(inputDate, inputCompany, inputCont, limitRow, 1);
        }
    };

    const onSearchCompany = (value) => {
        // console.log("search:", value);
    };

    const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());


    const closeMap = () => {
        setColor(null);
        setLatStart(null);
        setLongStart(null);
        setLatEnd(null);
        setLongEnd(null);
        setOpenMap(false);
        setMarkerPopup(null);
    };

    const exportToCSV = () => {
        const newRandomNumbers = Array.from({ length: 3 }, () =>
            Math.floor(Math.random() * 100)
        );
        const joinedNumbers = newRandomNumbers.join("");
        const filename = "tracking_cont_" + joinedNumbers;
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        const formatStart = startDate
            ? startDate.format("MM/DD/YYYY").toString()
            : "";
        const formatEnd = endDate ? endDate.format("MM/DD/YYYY").toString() : "";

        let stringDate = "*";
        if (formatStart && formatEnd) {
            stringDate = formatStart + ".." + formatEnd;
        }
        const inputDate = stringDate;
        const inputCompany = company ? company : "*";
        const inputCont = contNumber ? contNumber : "*";
        const limit = 1000;
        const offset = 1;

        getDataExpense(
            inputDate,
            inputCompany,
            inputCont,
            limit,
            offset,
            token
        )
            .then((res) => {
                if (res.data.messages[0].message === "OK") {
                    let results = res.data.response.data;
                    if (results && results.length > 0) {
                        // console.log(results);
                        let records = [];
                        records = results.map((row, key) => ({
                            'STT': key + 1,
                            'NGÀY': row.fieldData.NGAY,
                            'NGÀY KÉO XONG': row.fieldData.NgayKeoXong,
                            'NGÀY HẠ XONG': row.fieldData.NgayHaXong,
                            'HÃNG NHẬP/XUẤT': row.fieldData.HANG_NX,
                            'SIZE CONT': row.fieldData.SIZE_CONT,
                            'NHÓM KHÁCH HÀNG': row.fieldData.NHOM_KH,
                            'KHÁCH HÀNG': row.fieldData.KHACH_HANG,
                            'NƠI LẤY CONT': row.fieldData.NOI_LAY_CONT,
                            'NƠI HẠ CONT': row.fieldData.NOI_HA,
                            'Số Bill/Booking': row.fieldData.SO_HD,
                            'Số PO': row.fieldData.CUS_SO_PO,
                            'Số INVOICE': row.fieldData.CUS_SO_INVOICE,
                            'SỐ CONT': row.fieldData.SO_CONT,
                            'CƯỚC PHÍ': row.fieldData.CUOC_PHI,
                            'P. NÂNG CONT (HĐ)': row.fieldData.P_NangCont_HD,
                            'P. NÂNG CONT (TT)': row.fieldData.P_NangCont_TT,
                            'P. HẠ CONT (HĐ)': row.fieldData.P_HaCont_HD,
                            'P. HẠ CONT (TT)': row.fieldData.P_HaCont_TT,
                            'P. NÂNG PST (HĐ)': row.fieldData.P_NangPST_HD,
                            'P. NÂNG PST (TT)': row.fieldData.P_NangCont_TT,
                            'P. HẠ SỚM (HĐ)': row.fieldData.P_HaSom_HD,
                            'P. HẠ SỚM (TT)': row.fieldData.P_HaSom_TT,
                            'P. VỆ SINH CONT (HĐ)': row.fieldData.P_VeSinhCont_HD,
                            'P. VỆ SINH CONT (TT)': row.fieldData.P_VeSinhCont_TT,
                            'P. KHÁC (HĐ)': row.fieldData.P_Khac_HD,
                            'P. KHÁC (TT)': row.fieldData.P_Khac_TT,
                            'PP. TRÁI TUYẾN (TT)': row.fieldData.PP_TraiTuyen_TT,
                            'PP. CẢNG XA (TT)': row.fieldData.PP_CangXa_TT,
                            'PP. MUA CONT/SEAL (TT)': row.fieldData.PP_MuaContSeal_TT,
                            'PP. CẢNG ĐIỀU ĐỘ (TT)': row.fieldData.PP_CangDieuDo_TT,
                            'PP. LÀM HÀNG LẺ (TT)': row.fieldData.PP_LamHangLe_TT,
                            'PP. KHÁC (TT)': row.fieldData.PP_Khac_TT,
                            'PP. THANH LÝ (TT)': row.fieldData.PP_ThanhLy_TT,
                            'PP. NEO': row.fieldData.PP_Neo,
                            'SỐ NGÀY NEO': row.fieldData.SO_NGAY_NEO,
                            'TỔNG PHỤ PHÍ': row.fieldData.TONG_PHU_PHI,
                            'TỔNG CHI HỘ': row.fieldData.TONG_CHI_HO,
                            'TỔNG THANH TOÁN': row.fieldData.TONG_TT,
                            'SỐ HÓA ĐƠN': row.fieldData.InvoiceNumber,
                            'GHI CHÚ KÉO': row.fieldData.GHI_CHU_KEO,
                            'GHI CHÚ NEO': row.fieldData.GHI_CHU_NEO
                        }));

                        const Heading = [Object.keys(records[0])];
                        const ws = XLSX.utils.book_new();
                        XLSX.utils.sheet_add_aoa(ws, Heading);
                        XLSX.utils.sheet_add_json(ws, records, {
                            origin: "A2",
                            skipHeader: true,
                        });
                        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                        const excelBuffer = XLSX.write(wb, {
                            bookType: "xlsx",
                            type: "array",
                        });
                        const data = new Blob([excelBuffer], { type: fileType });
                        FileSaver.saveAs(data, filename + fileExtension);
                    }
                } else {
                }
            })
            .catch((error) => {
                // console.log(error);
            });
    };

    useEffect(() => {
        // Chỉ chạy 1 lần khi component mount
        if (isInitializedRef.current) return;
        isInitializedRef.current = true;

        const todayDate = dayjs(
            moment()
                .format("YYYY-MM-DD")
                .toString(),
            "YYYY-MM-DD"
        );
        setStartDate(todayDate);
        setEndDate(todayDate);

        const inputDate = `${moment().format("MM/DD/YYYY")}..${moment().format(
            "MM/DD/YYYY"
        )}`;
        getDataTable(inputDate, "*", "*", limitRow, 1);
        setCompanyListLoaded(false);
        // Initial data is loaded once with the filters captured on mount.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getWidthVehicle();
        window.addEventListener('resize', getWidthVehicle);
        return () => window.removeEventListener('resize', getWidthVehicle);
    }, []);

    const dpStyle = {
        maxWidth: "150px",
    };

    const handleOpenInNewTab = (soHd) => {
        const url = `${soHd}`;
        window.open(url, '_blank');
    };


    const [linkInvoice, setLinkInVoice] = useState('')

    const getInvoiceLink = async (data, mtc, mst, contNum) => {
        try {
            const res = await getInvoiceLinkAPI(data, token);
            const rawLink = res?.data?.response?.data?.[0]?.fieldData?.InvoiceLink;

            if (!rawLink) {
                console.warn("Không tìm thấy rawLink");
                return;
            }

            const replacements = {
                "{{MTC}}": mtc,
                "{{MST}}": mst,
                "{{SO_CONT}}": contNum,
            };

            let filledLink = rawLink;

            Object.entries(replacements).forEach(([placeholder, value]) => {
                if (value && filledLink.includes(placeholder)) {
                    filledLink = filledLink.replace(placeholder, value);
                }
            });

            setLinkInVoice(filledLink);
        } catch (err) {
            console.error("Lỗi khi lấy invoice link:", err);
        }
    };



    const formatValue = (value) => {
        if (!value) return ''; // kiểm tra 0, null, undefined
        return new Intl.NumberFormat('de-DE').format(value);
    };

    function createName(url) {
        let name;
        const parts = url.split("?")[0];
        const part = parts.split("/");
        const fileName = part[part.length - 1];

        if (fileName.length >= 9) {
            name = fileName.slice(-9);
        } else {
            name = fileName;
        }
        return name;
    }

    function PreviewImage(recordId, type) {
        const newUrlFiles = [];
        getFile(recordId, token)
            .then(async (data) => {
                console.log(data)
                let root = data.data.response.data[0];
                if (type === "HKR") {
                    for (let i = 1; i <= 10; i++) {
                        const url = root.fieldData[`HINH_KEO_CONT_RONG(${i})`];
                        if (url) {
                            const dimensions = await getImageSize(url);
                            // console.log(dimensions);
                            newUrlFiles.push({
                                url: url,
                                name: createName(root.fieldData[`HINH_KEO_CONT_RONG(${i})`]),
                                width: dimensions?.width,
                                height: dimensions?.height,
                            });
                        }
                    }
                } else if (type === "HKNM") {
                    for (let i = 1; i <= 3; i++) {
                        const url = root.fieldData[`HINH_KEO_NHA_MAY(${i})`];
                        if (url) {
                            const dimensions = await getImageSize(url);
                            newUrlFiles.push({
                                url: url,
                                name: createName(root.fieldData[`HINH_KEO_NHA_MAY(${i})`]),
                                width: dimensions?.width,
                                height: dimensions?.height,
                            });
                        }
                    }
                } else if (type === "HHNM") {
                    const url = root.fieldData[`HINH_HA_NHA_MAY(1)`];
                    if (url) {
                        const dimensions = await getImageSize(url);
                        newUrlFiles.push({
                            url: url,
                            name: createName(root.fieldData[`HINH_HA_NHA_MAY(1)`]),
                            width: dimensions?.width,
                            height: dimensions?.height,
                        });
                    }
                } else if (type === "HHHH") {
                    const imageConfigs = [
                        { fieldPrefix: "HINH_KEO_NHA_MAY", maxImages: 3 },
                        { fieldPrefix: "HINH_HA_HA_HANG", maxImages: 10 },
                        { fieldPrefix: "HINH_HA_NHA_MAY", maxImages: 10 },
                    ];

                    for (const { fieldPrefix, maxImages } of imageConfigs) {
                        for (let i = 1; i <= maxImages; i++) {
                            const url = root.fieldData[`${fieldPrefix}(${i})`];

                            if (url) {
                                console.log(fieldPrefix);
                                const dimensions = await getImageSize(url);
                                newUrlFiles.push({
                                    url: url,
                                    name: createName(root.fieldData[`${fieldPrefix}(${i})`]),
                                    width: dimensions?.width,
                                    height: dimensions?.height,
                                });
                            }
                        }
                    }
                }

                else if (type === "VGM") {
                    const url = root.fieldData["HINH_HA_NHA_MAY(1)"];
                    if (url) {
                        const dimensions = await getImageSize(url);
                        newUrlFiles.push({
                            url: url,
                            name: createName(root.fieldData[`HINH_HA_NHA_MAY(1)`]),
                            width: dimensions?.width,
                            height: dimensions?.height,
                        });
                    }
                }
            })
            .finally(() => {
                if (newUrlFiles.length > 0) {
                    setUrlImages(newUrlFiles);
                    setShowImages(true);

                    setTimeout(() => {
                        setReset(!reset);
                    }, 500);
                }
            });
    }


    return (
        <div>

            <Modal
                open={showImages}
                footer={null}
                onCancel={() => setShowImages(false)}
                width={550}
            >
                <GalleryImages images={urlImages} reset={reset} />
            </Modal>
            <Header onAction={handleSubmitWithAction} />

            <div className="custom-bg-filter">
                <div className="d-flex flex-row flex-nowrap overflow-auto">
                    <div className="flex-grow-1 pe-2 ps-0">
                        SỐ CONT/BK
                        <br />
                        <Input
                            className="ant-input"
                            type="text"
                            placeholder="Nhập số CONT/BK"
                            onChange={(event) => onContNumber(event.target.value)}
                            allowClear
                        />
                    </div>
                    <div className="flex-grow-1 pe-2">
                        CÔNG TY <br />
                        <Select
                            showSearch
                            allowClear
                            placeholder="Chọn công ty"
                            optionFilterProp="children"
                            onChange={onChangeCompany}
                            onSearch={onSearchCompany}
                            filterOption={filterOption}
                            options={optionsData}
                            onDropdownVisibleChange={handleCompanyDropdownVisibleChange}
                        />
                    </div>
                    <div className="flex-grow-1 pe-2">
                        TỪ NGÀY <br />
                        <DatePicker
                            placeholder="Chọn ngày"
                            className={"input-date"}
                            onChange={onSelectStartDate}
                            value={startDate}
                            format={dateFormat}
                            name="startDate"
                            style={dpStyle}
                        />
                    </div>
                    <div className="flex-grow-1 pe-2">
                        ĐẾN NGÀY <br />
                        <DatePicker
                            placeholder="Chọn ngày"
                            className={"input-date"}
                            onChange={onSelectEndDate}
                            value={endDate}
                            format={dateFormat}
                            name="endDate"
                            style={dpStyle}
                        />
                    </div>
                    <div className="button-container d-flex flex-row flex-nowrap me-0 pe-0 w-100">
                        <Button
                            className="custom-btn custom-btn-primary me-3 d-none"
                            size="sm"
                            onClick={handleSubmit}
                        >
                            Tra cứu
                        </Button>{" "}
                        <Button
                            className="custom-btn custom-btn-outline-primary ms-2 me-3"
                            size="sm"
                            variant="outline-primary"
                            onClick={exportToCSV}
                        >
                            Xuất Excel
                        </Button>{" "}
                        <Button
                            className="custom-btn-update custom-btn-primary"
                            size="sm"
                            variant="outline-primary"
                            onClick={handleSubmit}
                        >
                            <TfiReload className="me-1" />
                            Cập nhật
                        </Button>
                    </div>
                </div>
            </div>

            <div className="custom-table-sr">
                <Table bordered hover responsive="sm" className="custom-table">
                    <thead>
                        <tr className="sticky-header">
                            <th rowSpan="2">STT</th>
                            <th rowSpan="2">Ngày book</th>
                            <th rowSpan="2">Ngày nâng</th>
                            <th rowSpan="2">Ngày hạ</th>
                            <th rowSpan="2">Hàng XN</th>
                            <th rowSpan="2">Loại cont</th>
                            <th rowSpan="2">Nhóm KH</th>
                            <th rowSpan="2" ref={refXl1}>Khách hàng</th>
                            <th rowSpan="2" ref={refXl2}>Nơi lấy cont</th>
                            <th rowSpan="2" ref={refXh1}>Nơi hạ</th>
                            <th rowSpan="2" ref={refXh2}>Số Bill/Booking</th>
                            <th rowSpan="2">Số PO</th>
                            <th rowSpan="2">Số Invoice</th>

                            <th rowSpan="2" ref={refXh3}>Số cont</th>
                            <th rowSpan="2" ref={refXh4}>Cước vận chuyển</th>


                            <th colSpan="4">Phí nâng</th>
                            <th colSpan="4">Phí hạ</th>
                            <th colSpan="2">Phụ phí nâng</th>
                            <th colSpan="2">Hạ bãi sớm</th>
                            <th colSpan="2">Phí sửa / Vệ sinh cont</th>
                            <th colSpan="2">Phí khác</th>
                            <th colSpan="9">Phụ phí</th>

                            <th rowSpan="2" ref={refXh5}>TỔNG PHỤ PHÍ</th>
                            <th rowSpan="2" ref={refXh6}>TỔNG CHI HỘ</th>
                            <th rowSpan="2" ref={refXh7}>TỔNG CỘNG</th>
                            <th rowSpan="2" ref={refXh8}>ĐÃ XUẤT <br /> HÓA ĐƠN</th>
                            <th rowSpan="2" ref={refXh9}>GHI CHÚ KÉO</th>
                            <th rowSpan="2" ref={refXh10}>GHI CHÚ NEO</th>
                            {/* <th rowSpan="2" ref={refXh11}>TG TK xong</th>
                            <th rowSpan="2" ref={refXh12}>Nơi hạ Cont</th> */}

                        </tr>

                        <tr className="sub-header">
                            {/* =========Phí nâng========= */}
                            <th rowSpan="2">Hóa đơn</th>
                            <th rowSpan="2">Số tiền</th>
                            <th rowSpan="2">Tra cứu</th>
                            <th rowSpan='2'>Hình nâng</th>
                            {/* =========Phí nâng========= */}
                            <th rowSpan="2">Hóa đơn</th>
                            <th rowSpan="2">Số tiền</th>
                            <th rowSpan="2">Tra cứu</th>
                            <th rowSpan='2'>Hình hạ</th>
                            {/* =========Phụ phí nâng========= */}
                            <th rowSpan="2">Hóa đơn</th>
                            <th rowSpan="2">Số tiền</th>
                            {/* =========Hạ bãi sớm========= */}
                            <th rowSpan="2">Hóa đơn</th>
                            <th rowSpan="2">Số tiền</th>
                            {/* =========Phí sửa / Vệ sinh cont========= */}
                            <th rowSpan="2">Hóa đơn</th>
                            <th rowSpan="2">Số tiền</th>

                            {/* =========Phí khác========= */}
                            <th rowSpan="2">Hóa đơn</th>
                            <th rowSpan="2">Số tiền</th>
                            {/* =========Phụ phí========= */}
                            <th rowSpan="2">Trái tuyến</th>
                            <th rowSpan="2">Cảng xa</th>
                            <th rowSpan="2">Mua Cont/Seal</th>
                            <th rowSpan="2">Chi cảng/Điều độ</th>
                            <th rowSpan="2">Làm hàng lẻ</th>
                            <th rowSpan="2">Khác</th>
                            <th rowSpan="2">Thanh lý</th>
                            <th rowSpan="2">Neo</th>
                            <th rowSpan="2">Số ngày neo</th>


                        </tr>


                    </thead>

                    <tbody>
                        {data ? (
                            data.map((val, key) => {
                                return (
                                    <>
                                        <tr key={key}>
                                            <td className="text-center">{index + key}</td>
                                            <td>
                                                {val.fieldData.NGAY && (
                                                    <Moment format="DD/MM/YYYY">
                                                        {val.fieldData.NGAY}
                                                    </Moment>
                                                )}
                                            </td>

                                            <td>
                                                {val.fieldData.NgayKeoXong && (
                                                    <Moment format="DD/MM/YYYY">
                                                        {val.fieldData.NgayKeoXong}
                                                    </Moment>
                                                )}
                                            </td>

                                            <td>
                                                {val.fieldData.NgayHaXong && (
                                                    <Moment format="DD/MM/YYYY">
                                                        {val.fieldData.NgayHaXong}
                                                    </Moment>
                                                )}
                                            </td>

                                            <td className="text-center"> {val.fieldData.HANG_NX}</td>

                                            <td className="text-center"> {val.fieldData.SIZE_CONT}</td>

                                            <td className="text-center"> {val.fieldData.NHOM_KH}</td>

                                            <td className="text-start"> {val.fieldData.KHACH_HANG}</td>

                                            <td className="text-start"> {val.fieldData.NOI_LAY_CONT}</td>

                                            <td className="text-start"> {val.fieldData.NOI_HA}</td>

                                            <td className="text-start"> {val.fieldData.SO_BOOKING}</td>

                                            <td className="text-center"> {val.fieldData.CUS_SO_PO}</td>

                                            <td className="text-center"> {val.fieldData.CUS_SO_INVOICE}</td>

                                            <td className="text-start"> {val.fieldData.SO_CONT}</td>

                                            <td className="text-end"> {formatValue(val.fieldData.CUOC_PHI)}</td>

                                            <td > {val.fieldData.P_NangCont_HD} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.P_NangCont_TT)} </td>

                                            {val.fieldData.P_NangCont_HD ? <td className="text-center">

                                                <Popover
                                                    content={
                                                        <>
                                                            <ul className={"list-unstyled"}>
                                                                <li className={"ms-2"}>
                                                                    Số hóa đơn:{" "}
                                                                    {val.fieldData?.P_NangCont_HD}
                                                                </li>
                                                                <li className={"ms-2"}>
                                                                    Ngày hóa đơn:{" "}

                                                                    {val.fieldData.P_NangCont_Ngay && (
                                                                        <Moment format="DD/MM/YYYY">
                                                                            {val.fieldData.P_NangCont_Ngay}
                                                                        </Moment>
                                                                    )}

                                                                </li>
                                                                <li className={"ms-2"}>
                                                                    Thành tiền:{" "}
                                                                    {formatValue(val.fieldData.P_NangCont_TT)}

                                                                </li>
                                                                <li className={"ms-2"}>
                                                                    Mã tra cứu:{" "}
                                                                    {val.fieldData.P_NangCont_MaTraCuu}
                                                                </li>

                                                                {linkInvoice ? <li className={"ms-2"}>  <a href={linkInvoice} target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    aria-label="Invoice Link">Tra cứu hóa đơn</a></li> : ''}


                                                            </ul>
                                                        </>
                                                    }
                                                    title="Thông tin"
                                                    trigger="click"
                                                >
                                                    <TbFileSearch onClick={() => { getInvoiceLink(val.fieldData.NOI_LAY_CONT, val.fieldData.P_NangCont_MaTraCuu, val.fieldData.MA_SO_THUE, val.fieldData.SO_CONT) }} className="cursor-pointer" size={22} strokeWidth={1.5} color="#545E73" />
                                                </Popover>

                                            </td> : <td className="text-center "></td>}


                                            <td className="text-center">
                                                {val.fieldData.zcHinhKeoRong > 0 ? (
                                                    <button
                                                        className={"btn btn-sm p-0"}
                                                        onClick={() => PreviewImage(val.recordId, "HKR")}
                                                    >
                                                        <img src={iconImage} alt={"Icon"} width={16} />
                                                    </button>
                                                ) : (
                                                    ""
                                                )}
                                            </td>


                                            <td > {val.fieldData.P_HaCont_HD} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.P_HaCont_TT)} </td>

                                            {val.fieldData.P_HaCont_HD ? <td className="text-center ">

                                                <Popover
                                                    content={
                                                        <>
                                                            <ul className={"list-unstyled"}>
                                                                <li className={"ms-2"}>
                                                                    Số hóa đơn:{" "}
                                                                    {val.fieldData?.P_HaCont_HD}
                                                                </li>
                                                                <li className={"ms-2"}>
                                                                    Ngày hóa đơn:{" "}
                                                                    {val.fieldData.P_HaCont_Ngay && (
                                                                        <Moment format="DD/MM/YYYY">
                                                                            {val.fieldData.P_HaCont_Ngay}
                                                                        </Moment>
                                                                    )}
                                                                </li>
                                                                <li className={"ms-2"}>
                                                                    Thành tiền:{" "}
                                                                    {formatValue(val.fieldData.P_HaCont_TT)}

                                                                </li>
                                                                <li className={"ms-2"}>
                                                                    Mã tra cứu:{" "}
                                                                    {val.fieldData.P_HaCont_MaTraCuu}
                                                                </li>
                                                                {linkInvoice ? <li className={"ms-2"}> <a href={linkInvoice} target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    aria-label="Invoice Link">Tra cứu hóa đơn</a>
                                                                </li> : ''}
                                                            </ul>
                                                        </>
                                                    }
                                                    title="Thông tin"
                                                    trigger="click"
                                                >
                                                    <TbFileSearch onClick={() => { getInvoiceLink(val.fieldData.NOI_HA, val.fieldData.P_HaCont_MaTraCuu, val.fieldData.MA_SO_THUE, val.fieldData.SO_CONT) }} className="cursor-pointer" size={22} strokeWidth={1.5} color="#545E73" />
                                                </Popover>

                                            </td> : <td className="text-center "></td>}

                                            <td className="text-center">
                                                {(val.fieldData.zcHinhHaHaHang) > 0 ? (
                                                    <button
                                                        className={"btn btn-sm p-0"}
                                                        onClick={() => PreviewImage(val.recordId, "HHHH")}
                                                    >
                                                        <img src={iconImage} alt="" width={16} />
                                                    </button>
                                                ) : (
                                                    ""
                                                )}
                                            </td>


                                            {/* ===============Phụ phí nâng=================== */}

                                            <td > {val.fieldData.P_NangPST_HD} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.P_NangPST_TT)} </td>

                                            {/* ===============Hạ sớm=================== */}

                                            <td > {val.fieldData.P_HaSom_HD} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.P_HaSom_TT)} </td>

                                            {/* ===================Vệ sinh rửa Cont=================== */}

                                            <td > {val.fieldData.P_VeSinhCont_HD} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.P_VeSinhCont_TT)} </td>

                                            {/* ===================Khác=================== */}

                                            <td > {val.fieldData.P_Khac_HD} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.P_Khac_TT)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.PP_TraiTuyen_TT)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.PP_CangXa_TT)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.PP_MuaContSeal_TT)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.PP_CangDieuDo_TT)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.PP_LamHangLe_TT)} </td>


                                            <td className="text-end"> {formatValue(val.fieldData.PP_Khac_TT)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.PP_ThanhLy_TT)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.PP_Neo)} </td>


                                            <td className="text-center"> {val.fieldData.SO_NGAY_NEO} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.TONG_PHU_PHI)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.TONG_CHI_HO)} </td>

                                            <td className="text-end"> {formatValue(val.fieldData.TONG_TT)} </td>

                                            <td onClick={() => { handleOpenInNewTab(val.fieldData.InvoiceLink) }} className="text-center text-primary cursor-pointer">
                                                {val.fieldData.SO_HD}
                                            </td>

                                            <td className="text-start"> {val.fieldData.GHI_CHU_KEO}</td>

                                            <td className="text-start"> {val.fieldData.GHI_CHU_NEO}</td>


                                        </tr>
                                    </>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={25} className="text-center h5">
                                    {dataError}
                                </td>
                            </tr>
                        )}
                    </tbody >
                </Table>
            </div>

            <div className="custom-row-paginate d-flex align-items-center" style={{ marginBottom: '35px', minHeigh: '50px' }}>
                <div className={"col-12"}>
                    <div className={"align-items-center"}>
                        <div className={"hide-element text-black-50 pe-2"}>
                            <Grid>
                                <Grid item xs={12} sm={6}>
                                    <div className="d-flex gap-0" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <CustomTextFieldStyle className="gap-0 mb-2">
                                            Số dòng:
                                            <FormControl variant="standard" sx={{ border: "none" }}>
                                                <Select
                                                    variant="borderless"
                                                    defaultValue={limitRow}
                                                    onChange={(e) => {
                                                        handleChangeLimit(e);
                                                    }}
                                                    style={{
                                                        padding: 0,
                                                        width: "65px",
                                                        border: "none",
                                                    }}
                                                    marginInlineEnd={0}
                                                    optionPadding={0}
                                                    options={[
                                                        {
                                                            value: 10,
                                                            label: "10",
                                                        },
                                                        {
                                                            value: 20,
                                                            label: "20",
                                                        },
                                                        {
                                                            value: 50,
                                                            label: "50",
                                                        },
                                                        {
                                                            value: 100,
                                                            label: "100",
                                                        },
                                                    ]}
                                                ></Select>
                                            </FormControl>{" "}
                                            <span className="ms-1">
                                                {currentPage}-
                                                {Math.min(currentPage - 1 + limit, pageNumbers)} /{" "}
                                                {pageNumbers}
                                            </span>
                                        </CustomTextFieldStyle>
                                        <CustomTextFieldStyle className="ms-2 mb-2">
                                            {showPagination ? (
                                                <Grid item xs={12} sm={6}>
                                                    <Pagination
                                                        count={Math.ceil(pageNumbers / limit)}
                                                        size="small"
                                                        forcePage={forcePage}
                                                        shape="rounded"
                                                        showFirstButton
                                                        showLastButton
                                                        color="primary"
                                                        defaultPage={1}
                                                        variant="text"
                                                        onChange={handleChangePage}
                                                        style={{ margin: "0 0 0 0", float: "right" }}
                                                    />
                                                </Grid>
                                            ) : null}
                                        </CustomTextFieldStyle>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}><Footer /></div>
            <Modal
                open={openMap}
                onOk={closeMap}
                onCancel={closeMap}
                footer={null}
                width={1200}
            >
                {latStart && longStart && latEnd && longEnd && (
                    <MapContainer
                        doubleClickZoom={false}
                        scrollWheelZoom={true}
                        id="mapId"
                        zoom={15}
                        center={[latStart, longStart]}
                        style={{ width: "100%", height: "110vh" }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="Map data &copy; OpenStreetMap contributors"
                        />

                        <RoutineMachine
                            latStart={latStart}
                            longStart={longStart}
                            latEnd={latEnd}
                            longEnd={longEnd}
                            color={color}
                            markerPopup={markerPopup}
                            markerPopupType={markerPopupType}
                        />
                    </MapContainer>
                )}
            </Modal>
            <ToastContainer />
        </div>
    );
};

export default DataTable;
